var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Shedules_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shedules_Icon",
    "data-name": "Shedules Icon",
    clipPath: "url(#clip-Shedules_Icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3655",
    "data-name": "Group 3655",
    transform: "translate(-0.596 -1.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3643",
    "data-name": "Group 3643",
    transform: "translate(0.598 7.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5908",
    "data-name": "Path 5908",
    d: "M17.452,19.636H1.744A1.145,1.145,0,0,1,.6,18.49V9.475h.584V18.49a.554.554,0,0,0,.164.4.56.56,0,0,0,.4.164H17.452a.56.56,0,0,0,.4-.164.551.551,0,0,0,.164-.4V9.475H18.6V18.49a1.146,1.146,0,0,1-1.145,1.146Z",
    transform: "translate(-0.599 -9.475)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3644",
    "data-name": "Group 3644",
    transform: "translate(4.017 4.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5909",
    "data-name": "Path 5909",
    d: "M5.7,6.485A1.094,1.094,0,0,1,4.684,4.963a.292.292,0,0,1,.538.228.5.5,0,0,0-.04.2.515.515,0,1,0,1.029,0,.492.492,0,0,0-.039-.194.292.292,0,1,1,.537-.229,1.068,1.068,0,0,1,.087.424A1.1,1.1,0,0,1,5.7,6.485Z",
    transform: "translate(-4.597 -4.784)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3645",
    "data-name": "Group 3645",
    transform: "translate(4.822 2.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5910",
    "data-name": "Path 5910",
    d: "M5.991,5.076A.292.292,0,0,1,5.7,4.783V2.893a.292.292,0,0,1,.584,0v1.89A.293.293,0,0,1,5.991,5.076Z",
    transform: "translate(-5.699 -2.601)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646",
    transform: "translate(12.777 4.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5911",
    "data-name": "Path 5911",
    d: "M19.327,6.485a1.1,1.1,0,0,1-1.1-1.1,1.072,1.072,0,0,1,.088-.424.292.292,0,0,1,.536.231.488.488,0,0,0-.039.194.515.515,0,1,0,1.029,0,.509.509,0,0,0-.04-.2.292.292,0,0,1,.538-.228,1.077,1.077,0,0,1,.087.423A1.1,1.1,0,0,1,19.327,6.485Z",
    transform: "translate(-18.228 -4.784)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647",
    transform: "translate(13.585 2.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5912",
    "data-name": "Path 5912",
    d: "M19.626,5.076a.293.293,0,0,1-.292-.292V2.893a.293.293,0,0,1,.585,0v1.89A.293.293,0,0,1,19.626,5.076Z",
    transform: "translate(-19.334 -2.601)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648",
    transform: "translate(5.216 3.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5913",
    "data-name": "Path 5913",
    d: "M14.39,3.9H8.212a.292.292,0,1,1,0-.584H14.39a.292.292,0,0,1,0,.584Z",
    transform: "translate(-6.92 -3.317)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649",
    transform: "translate(0.596 3.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5914",
    "data-name": "Path 5914",
    d: "M18.593,8.107H.6V4.459A1.146,1.146,0,0,1,1.741,3.314H3.728a.292.292,0,1,1,0,.584H1.741a.561.561,0,0,0-.56.56V7.522H18.009V4.459a.561.561,0,0,0-.56-.56H15.467a.292.292,0,1,1,0-.584h1.981a1.146,1.146,0,0,1,1.145,1.145Z",
    transform: "translate(-0.596 -3.314)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650",
    transform: "translate(5.782 8.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5915",
    "data-name": "Path 5915",
    d: "M11.509,18.639a3.778,3.778,0,0,1-1.46-.29A3.792,3.792,0,0,1,9.39,18a3.81,3.81,0,0,1-1.406-1.713,3.79,3.79,0,0,1-.217-.715,3.814,3.814,0,0,1,4.487-4.486,3.79,3.79,0,0,1,.715.217,3.835,3.835,0,0,1,.659.352,3.763,3.763,0,0,1,.579.475,3.82,3.82,0,0,1,.475.578,3.819,3.819,0,0,1,.57,2.864,3.83,3.83,0,0,1-.57,1.375,3.854,3.854,0,0,1-.475.579,3.854,3.854,0,0,1-1.238.828,3.774,3.774,0,0,1-1.459.289Zm0-7.046a3.236,3.236,0,0,0-1.8.544,3.231,3.231,0,0,0-1.189,1.45,3.159,3.159,0,0,0-.184.606,3.232,3.232,0,0,0,0,1.261,3.163,3.163,0,0,0,.184.606,3.242,3.242,0,0,0,.3.56,3.207,3.207,0,0,0,.4.488,3.168,3.168,0,0,0,.49.4,3.292,3.292,0,0,0,.558.3,3.206,3.206,0,0,0,.607.183,3.225,3.225,0,0,0,2.425-.483,3.155,3.155,0,0,0,.489-.4,3.2,3.2,0,0,0,.7-1.047,3.335,3.335,0,0,0,.184-.607,3.266,3.266,0,0,0,0-1.26,3.266,3.266,0,0,0-.184-.606,3.21,3.21,0,0,0-.3-.558,3.226,3.226,0,0,0-1.45-1.189,3.152,3.152,0,0,0-.606-.183A3.2,3.2,0,0,0,11.509,11.593Z",
    transform: "translate(-7.694 -11.009)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651",
    transform: "translate(9.306 10.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    d: "M12.809,17.533a.293.293,0,0,1-.292-.293V13.7a.292.292,0,0,1,.584,0v3.541A.293.293,0,0,1,12.809,17.533Z",
    transform: "translate(-12.517 -13.407)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(7.535 12.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M13.927,16.415H10.385a.293.293,0,0,1,0-.585h3.541a.293.293,0,0,1,0,.585Z",
    transform: "translate(-10.093 -15.83)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653",
    transform: "translate(13.877 11.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    d: "M22.376,19.905V14.718l-3.6,5.214h3.58a.025.025,0,0,0,.022-.026Z",
    transform: "translate(-18.774 -14.718)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3654",
    "data-name": "Group 3654",
    transform: "translate(1.818 11.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5919",
    "data-name": "Path 5919",
    d: "M2.269,19.905V14.718l3.6,5.214H2.291a.024.024,0,0,1-.022-.026Z",
    transform: "translate(-2.269 -14.718)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.8d9b584cb1c269c67f2e82cd5b115aff.svg";
export { ForwardRef as ReactComponent };